import { render, staticRenderFns } from "./afterOrderClaim.vue?vue&type=template&id=4258a094"
import script from "./afterOrderClaim.vue?vue&type=script&lang=js"
export * from "./afterOrderClaim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports